(function () {
  "use strict";

  function initBeforeAfter(root) {
    if (!root || root.dataset.mfyReady === "true") return;
    var range = root.querySelector(".mfy-before-after__range");
    if (!range) return;

    function update() {
      root.style.setProperty("--mfy-ba-position", range.value + "%");
    }

    range.addEventListener("input", update);
    update();
    root.dataset.mfyReady = "true";
  }

  function initPosterGallery(root) {
    if (!root || root.dataset.mfyGalleryReady === "true") return;

    var track = root.querySelector(".gallery__track");
    var slides = Array.prototype.slice.call(root.querySelectorAll(".gallery__slide"));
    var previous = root.querySelector('[data-gallery-direction="-1"]');
    var next = root.querySelector('[data-gallery-direction="1"]');
    var counter = root.querySelector("[data-gallery-counter]");
    var thumbs = Array.prototype.slice.call(root.querySelectorAll(".gthumb"));
    var frame = 0;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!track || slides.length < 2) return;

    function currentIndex() {
      var nearest = 0;
      var distance = Infinity;
      slides.forEach(function (slide, index) {
        var delta = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (delta < distance) {
          nearest = index;
          distance = delta;
        }
      });
      return nearest;
    }

    function update() {
      var index = currentIndex();
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (counter) counter.textContent = index + 1 + " / " + slides.length;
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle("is-active", thumbIndex === index);
        thumb.setAttribute("aria-current", thumbIndex === index ? "true" : "false");
      });
    }

    function goTo(index) {
      var safeIndex = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: reduceMotion ? "auto" : "smooth" });
    }

    root.querySelectorAll("[data-gallery-direction]").forEach(function (button) {
      button.addEventListener("click", function () {
        goTo(currentIndex() + Number(button.dataset.galleryDirection || 0));
      });
    });

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () { goTo(index); });
    });

    track.addEventListener("scroll", function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });

    root.dataset.mfyGalleryReady = "true";
    update();
  }

  function initTeeinblueEditorGuard() {
    var body = document.body;
    if (!body || body.dataset.mfyEditorGuardReady === "true") return;

    var sticky = document.getElementById("pdp-sticky");
    var teeinblueContextSelector = "#teeinblue-wrapper, #teeinblue-form, [id*='teeinblue'], [class*='teeinblue'], [class*='tee-'], .uploadly-app-slot";
    var teeinblue = document.querySelector(teeinblueContextSelector);
    if (!sticky || !teeinblue) return;

    var frame = 0;
    var openingUntil = 0;
    var editorClass = "mfy-image-editor-open";
    var controlSelector = "button, [role='button'], input[type='button'], input[type='submit'], a";
    var savePattern = /(^|\s)(speichern|save|uebernehmen|übernehmen|anwenden|apply|fertig|done)(\s|$)/i;
    var editPattern = /(bild|foto|image|photo).*(anpassen|bearbeiten|edit|adjust|crop)|(anpassen|bearbeiten|edit|adjust|crop).*(bild|foto|image|photo)/i;
    var closePattern = /(^|\s)(speichern|save|uebernehmen|übernehmen|anwenden|apply|fertig|done|abbrechen|cancel|schliessen|schließen|close)(\s|$)/i;

    function labelOf(element) {
      if (!element) return "";
      return [
        element.textContent,
        element.getAttribute("aria-label"),
        element.getAttribute("title"),
        element.value
      ].filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
    }

    function isRendered(element) {
      if (!element || !element.isConnected || element.hidden) return false;
      var style = window.getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) return false;
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    function belongsToTeeinblueEditor(control) {
      if (!control) return false;
      if (control.closest(teeinblueContextSelector)) return true;

      var panel = control.closest("dialog, [role='dialog'], [aria-modal='true'], [class*='modal'], [class*='popup'], [class*='drawer'], [class*='editor'], [class*='crop']");
      if (!panel || !isRendered(panel)) return false;

      return Boolean(panel.querySelector("canvas, svg, [class*='crop'], [class*='image'], [class*='photo']"));
    }

    function hasOpenEditor() {
      var controls = document.querySelectorAll(controlSelector);
      for (var index = 0; index < controls.length; index += 1) {
        var control = controls[index];
        if (savePattern.test(labelOf(control)) && isRendered(control) && belongsToTeeinblueEditor(control)) {
          return true;
        }
      }
      return false;
    }

    function setEditorOpen(open) {
      body.classList.toggle(editorClass, open);
      document.documentElement.style.setProperty(
        "--sticky-h",
        !open && sticky.classList.contains("is-visible") ? sticky.offsetHeight + "px" : "0px"
      );
    }

    function sync() {
      frame = 0;
      setEditorOpen(hasOpenEditor() || Date.now() < openingUntil);
    }

    function scheduleSync() {
      if (frame) return;
      frame = window.requestAnimationFrame(sync);
    }

    document.addEventListener("click", function (event) {
      var control = event.target.closest && event.target.closest(controlSelector);
      if (!control) return;

      var label = labelOf(control);
      var inTeeinblue = control.closest(teeinblueContextSelector);

      if (inTeeinblue && editPattern.test(label)) {
        openingUntil = Date.now() + 2500;
        setEditorOpen(true);
      } else if (body.classList.contains(editorClass) && closePattern.test(label)) {
        openingUntil = 0;
      }

      window.setTimeout(scheduleSync, 0);
      window.setTimeout(scheduleSync, 180);
      window.setTimeout(scheduleSync, 500);
    }, true);

    new MutationObserver(scheduleSync).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "hidden", "aria-hidden", "aria-modal", "open"]
    });

    window.addEventListener("resize", scheduleSync, { passive: true });
    body.dataset.mfyEditorGuardReady = "true";
    scheduleSync();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-mfy-before-after]").forEach(initBeforeAfter);
    (scope || document).querySelectorAll("[data-mfy-product-gallery]").forEach(initPosterGallery);
    initTeeinblueEditorGuard();
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      (scope || document).querySelectorAll(".mfy-media-card__media video[autoplay]").forEach(function (video) {
        video.pause();
      });
    }
  }

  initAll(document);
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
